import React from 'react'
import {useDispatch} from 'react-redux'
import * as moment from 'moment'
import { changeSingleClientModal, setSingleClientActiveSale, setSingleClientActiveSalesKey } from '../../../../../../../redux/actions/single-client'
import NumberFormat from 'react-number-format'
import { InfoTableButton } from '../../../../../../library/button'

const Index = ({sale, index, arr}) => {

	const dispatch = useDispatch()

	const handleClickDelete = key => {
		dispatch(setSingleClientActiveSalesKey(key))
		dispatch(changeSingleClientModal({removeSaleModal: true}))
	}

	const handleClickEdit = sale => {
		dispatch(changeSingleClientModal({editSaleModal: true}))
		dispatch(setSingleClientActiveSale(sale))
	}

	const renderStatus = status => {
		switch(status){
			case 'Betalt':
				return <InfoTableButton color="green" title="Betalt"/>
			case 'Ikke betalt':
				return <InfoTableButton color="red" title="Ikke betalt"/>
			case 'Kreditert':
				return <InfoTableButton color="yellow" title="Kreditert"/>
			default:
				return null
		}
	}

	return(
		<tr className={index === arr.length - 1 ? 'bottom':''}>
    		<td>{moment.unix(sale.timestamp).format('DD/MM/YYYY')}</td>
			<td>{sale.title}</td>
			<td>{renderStatus(sale.status)}</td>
			<td className="price"><NumberFormat displayType={'text'} thousandSeparator={' '} value={sale.price * sale.vat}/>kr</td>
      		<td><button className="action-button" onClick={() => handleClickEdit(sale)}><i className="far fa-edit"></i></button><button className="action-button" onClick={() => handleClickDelete(sale.key)}><i className="far fa-trash-alt"></i></button></td>
    	</tr>
	)
}

export default Index


